import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { id } from '@swimlane/ngx-datatable';
import { UpdateTransaciton } from 'app/dtos/Transaction/updateTransaction';
import { UpdateTransacitonStatus } from 'app/dtos/Transaction/updateTransactionStatus';
import { AuthService } from 'app/services/auth.service';
import { ExpenseService } from 'app/services/models/expense.service';
import { ProjectService } from 'app/services/models/project.service';
import { TransactionDescriptionService } from 'app/services/models/transaction-description.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-transaction-update',
  templateUrl: './transaction-update.component.html',
  styleUrls: ['./transaction-update.component.scss']
})
export class TransactionUpdateComponent implements OnInit {
  @Input() data;
  transactionManagement: any = {};
  project: any[] = [];
  descriptions: any[] = [];
  selectedDescriptionId: any;
  expenses: any[] = [];
  selectedExpense: any = null;
  constructor(
    public ngbModal: NgbActiveModal,
    private transactionService: TransactionService,
    private cdr: ChangeDetectorRef,
    private toastService: ToastrService,
    private projectService: ProjectService,
    private transactionDescriptionService: TransactionDescriptionService,
    private expenseService: ExpenseService,
    public authService: AuthService
  ) { }

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,

  };

  onDescriptionChange(event: any) {
    console.log('Yeni seçilen değer:', event.target.value);
    this.selectedDescriptionId = event.target.value;  // Eğer seçilen değeri başka yerde kullanacaksanız
  }

  async ngOnInit() {
    await this.getByIdTransaction(this.data);
    this.initializeDates();
    const projectAuthorization = this.authService.isEndpointStatus('GET.Reading.GetAllProject');
    if (projectAuthorization) {
      await this.getAllProjects();
    }
    await this.getAllDescriptions();
    const expenseAuthorization = this.authService.isEndpointStatus('GET.Reading.GetAllExpenses');
    if (expenseAuthorization) {
      await this.getAllExpense();
    }
    this.selectedProject = this.transactionManagement?.project[0]?.productId;
    this.selectedDescriptionId = this.transactionManagement?.transactionManagementDescriptionConnect[0]?.transactionManagementDescriptionId;
  }

  async getAllExpense() {
    const data = await this.expenseService.getExpense();
    console.log(data);
    this.expenses = data;
  }

  onTransactionExpenseChange(event) {
    console.log(event.target.value);
    this.selectedExpense = event.target.value;
  }

  async getAllDescriptions() {
    const data = await this.transactionDescriptionService.getAllTransactionDescriptions();
    console.log(data);
    this.descriptions = data;
  }

  async getByIdTransaction(id) {
    const data = await this.transactionService.ByIdUpdateDetailTransaction(id);
    this.transactionManagement = data;
    console.log(this.transactionManagement);
    this.transactionManagement.requestTaskTransaction = this.transactionManagement.requestTaskTransaction || { requestTaskId: null };
    this.initializeDates();
  }

  async getAllProjects() {

    const data = await this.projectService.getAllProject(0, 100, '', 1);
    this.project = data.projects;
    console.log(this.project);
  }


  selectedProject? = null;
  onProjectChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.selectedProject = selectedValue ? + selectedValue : null; // Convert to number or null
    console.log(this.selectedProject); // Logs the selected project ID or null
  }


  async updateTransactionManagement() {
    const updatedTransaction: UpdateTransaciton = {
      id: this.transactionManagement.id,
      requestTaskId: this.transactionManagement.requestTaskTransaction?.requestTaskId,
      personId: this.transactionManagement.personId,
      startDate: new Date(this.transactionManagement.transactionCraetedAt),
      endDate: new Date(this.transactionManagement.validityDate),
      transactionPrivateNode: this.transactionManagement.transactionPrivateNode,
      docNo: this.transactionManagement?.documentNo,
      projectId: this.selectedProject,
      projectTransactionManagementId: this.transactionManagement?.project[0]?.id ?? null,
      descriptionId: this.transactionManagement.transactionManagementDescriptionConnect.length > 0 ? this.transactionManagement.transactionManagementDescriptionConnect[0].id : (this.selectedDescriptionId != null ? this.transactionManagement.id : null),
      selectedDescriptionId: this.selectedDescriptionId ?? null,
      expenseTransactionId: this.transactionManagement.expenseTransactions[0]?.id ?? null,
      expenseId: this.selectedExpense ?? null
    };
    console.log(updatedTransaction);
    const data = await this.transactionService.UpdateDetailTransactionMagenemnt(updatedTransaction);
    if (data.status == true) {
      this.toastService.success(data.message);
      this.transactionService.sendEvent(true);
      this.closeModal();
    } else {
      this.toastService.error(data.message);
    }
  }

  initializeDates() {
    if (this.transactionManagement.transactionCraetedAt) {
      this.transactionManagement.transactionCraetedAt = new Date(this.transactionManagement.transactionCraetedAt);
    }
    if (this.transactionManagement.validityDate) {
      this.transactionManagement.validityDate = new Date(this.transactionManagement.validityDate);
    }
    this.cdr.detectChanges();
  }

  closeModal() {
    this.ngbModal.close();
  }

}
